export const SERVICE_PRICE_CURRENCY_OPTIONS = Object.freeze([
  "AOA",
  "BWP",
  "CDF",
  "CHF",
  "EUR",
  "GBP",
  "GHS",
  "SZL",
  "LSL",
  "MWK",
  "MZN",
  "NAD",
  "ZAR",
  "TZS",
  "ZMW",
  "ZWG",
  "USD",
]);

const SERVICE_PRICE_CURRENCY_ALLOWLIST = new Set(SERVICE_PRICE_CURRENCY_OPTIONS);

export function normalizeServicePriceCurrency(value, fallback = "BWP") {
  const raw = String(value || "").trim().toUpperCase();
  const normalized = raw === "FC" ? "CDF" : raw;
  if (SERVICE_PRICE_CURRENCY_ALLOWLIST.has(normalized)) return normalized;
  const fallbackCode = String(fallback || "BWP").trim().toUpperCase();
  return SERVICE_PRICE_CURRENCY_ALLOWLIST.has(fallbackCode) ? fallbackCode : "BWP";
}

export function normalizeServicePriceValue(value) {
  return String(value ?? "").trim().replace(",", ".");
}

export function isValidServicePrice(value) {
  const normalized = normalizeServicePriceValue(value);
  if (!normalized) return false;
  const amount = Number(normalized);
  return Number.isFinite(amount) && amount >= 0;
}
